export default () => {
  return "PFC-" + "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (character) => {
    const random = Math.floor(Math.random() * 16);
    // tslint:disable-next-line:no-bitwise
    const value = character === "x" ? random : (random & 0x3 | 0x8);
    return value.toString(16);
  });
};
